function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.344 5.186h10.603a.686.686 0 0 0 0-1.372H2.344l2.641-2.642a.686.686 0 0 0-.97-.97L.2 4.014a.686.686 0 0 0 0 .97L4.015 8.8a.686.686 0 0 0 .97-.97L2.344 5.185z",
  fill: "#637280",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 9
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/back_home.b77884a6.svg";
export { SvgComponent as ReactComponent };